import API, { defaultHeaders } from '@/api';

const fetchListing = (page = 1, query = null, pagination = true) => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  let url = `${API}/panel/tags?page=${page}${query ? `&query=${query}` : ''}`;
  if (pagination === false) {
    url = `${API}/panel/tags?pagination=0`;
  }

  return fetch(url, { headers });
};

export default fetchListing;
